<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.num')">
                    <el-select
                      v-model="formInline.selectCarType"
                      style="width: 120px"
                      :placeholder="$t('common.form.choseTip')"
                      class="selectStyle"
                    >
                      <el-option
                        v-for="item in optionsInput"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-model="formInline.selectCarValue"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('OTAManagement.typeIdStr')">
                    <el-select
                      v-model="formInline.typeId"
                      :placeholder="$t('common.form.choseTip')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in terminalList"
                        :key="item.id"
                        :label="item.terminalType"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input
                      size="mini"
                      v-model="formInline.terminalId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.driverName')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="$t('VehicleManagement.offlineDuration')"
                  >
                    <el-select
                      v-model="formInline.offlineTime"
                      :placeholder="$t('common.form.choseTip')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in offlineList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.deviceStatus')">
                    <el-select
                      v-model="formInline.linkState"
                      :placeholder="$t('common.form.choseTip')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in StateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.workCondition')">
                    <el-select
                      v-model="formInline.onoffState"
                      :placeholder="$t('common.form.choseTip')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in alarmList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="$t('VehicleManagement.faultConditions')"
                  >
                    <el-select
                      v-model="formInline.problem"
                      :placeholder="$t('common.form.choseTip')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in problemList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('VEHICLESTATUS_VEHICLEPOSITION')"
                  type="text"
                  @click="carCheck"
                  :disabled="selected.length != 1"
                  >{{ $t("VehicleManagement.btn.inspectionEnable") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('VEHICLESTATUS_VEHICLEPOSITION')"
                  type="text"
                  @click="carLocation"
                  :disabled="selected.length != 1"
                  >{{ $t("VehicleManagement.btn.vehiclePosition") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('VEHICLESTATUS_DOWN')"
                  type="text"
                  @click="downCar"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="720px"
        :visible.sync="dialogCheckFormVisible"
        :title="$t('VehicleManagement.btn.inspectionEnable')"
        class="carDialong"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            :label="$t('VehicleManagement.IsThereSpotCheck') + ':'"
            :label-width="formLabelWidth"
            prop="spotCheckState"
          >
            <el-select
              v-model="form.spotCheckState"
              :placeholder="$t('common.form.choseTip')"
            >
              <el-option
                :label="$t('VehicleManagement.deny')"
                value="0"
              ></el-option>
              <el-option
                :label="$t('VehicleManagement.correct')"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="720px"
        :visible.sync="dialogFormVisible"
        :title="$t('common.btn.detail')"
        class="bombDialong"
        :close-on-click-modal="false"
      >
        <div class="allDialong">
          <div class="carImg" style="width: 96px; height: 60px">
            <div>{{ $t("common.carId") }}</div>
            <div>{{ carId }}</div>
          </div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane name="first">
              <span slot="label"
                ><i class="iconfont icon-cheliangliebiao"></i>
                <div>{{ $t("VehicleManagement.carInfom") }}</div></span
              >
              <VehicleInformation
                :bind-car="carId"
                ref="carInformation"
              ></VehicleInformation>
            </el-tab-pane>
            <el-tab-pane name="second">
              <span slot="label"
                ><i class="iconfont icon-anzhuo"></i>
                <div>{{ $t("VehicleManagement.termianlInform") }}</div></span
              >
              <TerminalInformation
                :bind-terminal="terminalId"
                ref="terminalInformation"
              ></TerminalInformation>
            </el-tab-pane>
            <el-tab-pane name="third">
              <span slot="label"
                ><i class="iconfont icon-jiashiyuandanganguanli"></i>
                <div>{{ $t("VehicleManagement.driverInform") }}</div></span
              >
              <DriverInformation
                :bind-driver="driverNum"
                ref="driverInformation"
              ></DriverInformation>
            </el-tab-pane>
            <el-tab-pane name="fourth">
              <span slot="label"
                ><i class="iconfont icon-gongzuotai"></i>
                <div>{{ $t("VehicleManagement.carWorkStatus") }}</div></span
              >
              <VehicleWorking
                :bind-car="carId"
                ref="vehicleWorking"
              ></VehicleWorking>
            </el-tab-pane>
            <el-tab-pane name="fifth" :lazy="true">
              <span slot="label"
                ><i class="iconfont icon-gongzuotai"></i>
                <div>{{ $t("VehicleManagement.runningData") }}</div></span
              >
              <div v-if="'fifth' === activeName">
                <RunningData
                  :bind-terminal="terminalId"
                  ref="runningData"
                ></RunningData>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>
      <el-dialog
        :title="$t('VehicleManagement.btn.vehiclePosition')"
        class="bombDialong"
        v-if="dialogVisibleNone"
        :visible.sync="dialogVisible"
        width="90%"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <roadBook ref="roadBook" :bind-car="carData"></roadBook>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import VehicleStatus from "./VehicleStatus.js";
export default VehicleStatus;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
/deep/.el-tabs__nav {
}
</style>
